<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-input v-model="tableQuery.name" style="width: 200px;margin-right: 10px" @change="selectPage" placeholder="请输入商品名称"></el-input>
      <el-date-picker style="margin-right: 10px"
          v-model="tableQuery.dateSection"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期" @change="selectPage">
      </el-date-picker>
      <el-button type="danger" icon="el-icon-download" @click="exchangeDetailExcel">导出</el-button>
    </div>
    <el-table border class="table" :data="tableData" height="600px" v-loading="tableQuery.loading" empty-text="空空如也～ 新增一条吧！">
      <el-table-column prop="name" label="商品"/>
      <el-table-column prop="coachName" label="兑换老师"/>
      <el-table-column prop="handleCoachName" label="领取老师"/>
      <el-table-column label="消耗积分" >
        <template #default="scope">
          {{scope.row.score}}积分
        </template>
      </el-table-column>
      <el-table-column prop="addTime" label="兑换日期" width="180">
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right;margin: 20px 10px"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="tableQuery.pageSize"
        @current-change="changePage"
        layout="total, prev, pager, next, jumper"
        :total="tableQuery.total">
    </el-pagination>
  </div>
</template>

<script>
import {selectExchangeDetail,exchangeDetailExcel} from "../../../../../../api/contacts/hr/product";
export default {
  name: "ExchangeDetail",
  data() {
    return {
      tableData:[],
      tableQuery:{
        name:"",
        pageIndex:0,
        pageSize:11,
        loading:false,
        dateSection:null,
        total:0
      }
    }
  },
  methods:{
    changePage(index){
      this.tableQuery.pageIndex = index;
      this.selectPage();
    },
    selectPage(){
      this.tableQuery.loading = true;
      if (this.tableQuery.dateSection){
        this.tableQuery.startTime = this.tableQuery.dateSection[0];
        this.tableQuery.endTime = this.tableQuery.dateSection[1];
      }else {
        this.tableQuery.startTime = null;
        this.tableQuery.endTime = null;
      }
      selectExchangeDetail(this.tableQuery).then(val=>{
        this.tableQuery.loading = false;
        if (val.status == 200){
          this.tableData = val.data.list;
          this.tableQuery.total = val.data.total;
        }
      })
    },
    exchangeDetailExcel(){
      this.tableQuery.loading = true;
      if (this.tableQuery.dateSection){
        this.tableQuery.startTime = this.tableQuery.dateSection[0];
        this.tableQuery.endTime = this.tableQuery.dateSection[1];
      }else {
        this.tableQuery.startTime = null;
        this.tableQuery.endTime = null;
      }
      exchangeDetailExcel(this.tableQuery).then(val=>{
        this.tableQuery.loading = false;
        if (val.status == 200){
          let url = val.data;
          window.URL = window.URL || window.webkitURL;
          var name = url.substring(url.lastIndexOf("/") + 1, url.length);
          var xhr = new XMLHttpRequest();
          var a = document.createElement("a");
          xhr.open("GET", url, true);
          xhr.responseType = "blob";
          xhr.onload = function() {
            var file = new Blob([xhr.response], { type: "application/octet-stream" });
            a.href = window.URL.createObjectURL(file);
            a.download = name;
            a.click();
          };
          xhr.send();
        }
      })
    },
  },
  created() {
    this.selectPage();
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
</style>